// Send single ping
export const SendPing = (url, result) => {
	url += (url.match(/\?/) ? "&" : "?") + "cors=true&r=" + Math.random();

	var time = new Date().getTime();

	var xhr = new XMLHttpRequest();
	xhr.onload = function() {
		var pingTime = new Date().getTime() - time;

		try {
			//try to get more accurate timing using performance API
			var p = performance.getEntriesByName(url);
			p = p[p.length - 1];
			var d = p.responseStart - p.requestStart;
			if (d <= 0) d = p.duration;
			if (d > 0 && d < pingTime) pingTime = d;
		} catch (e) {}

		result(parseInt(pingTime));
	};

	xhr.onerror = function() {
		result(-1);
	};

	xhr.open("GET", url);
	xhr.send();
}

// Stops all XHR activity, aggressively
export const ClearRequests = (xhr) => {
	if (xhr) {
		for (var i = 0; i < xhr.length; i++) {
			try {
				xhr[i].onprogress = null;
				xhr[i].onload = null;
				xhr[i].onerror = null;
			} catch (e) {}
			try {
				xhr[i].upload.onprogress = null;
				xhr[i].upload.onload = null;
				xhr[i].upload.onerror = null;
			} catch (e) {}
			try {
				xhr[i].abort();
			} catch (e) {}
			try {
				delete xhr[i];
			} catch (e) {}
		}
	}
	return null;
}

/**
 * Creates and loads an image element by url.
 * @param  {String} url
 * @return {Promise} promise that resolves to an image element or
 *                   fails to an Error.
 */
function request_image(url) {
	return new Promise(function(resolve, reject) {
		var img = new Image();
		img.onload = function() { resolve(img); };
		img.onerror = function() { reject(url); };
		img.src = url + '?random-no-cache=' + Math.floor((1 + Math.random()) * 0x10000).toString(16);
	});
}

/**
 * Pings a url.
 * @param  {String} url
 * @param  {Number} multiplier - optional, factor to adjust the ping by.  0.3 works well for HTTP servers.
 * @return {Promise} promise that resolves to a ping (ms, float).
 */
export const Ping = (url, multiplier) => {
	return new Promise(function(resolve, reject) {
		var start = (new Date()).getTime();
		var response = function() {
			var delta = ((new Date()).getTime() - start);
			delta *= (multiplier || 1);
			resolve(delta);
		};
		request_image(url).then(response).catch(response);

		// Set a timeout for max-pings, 5s.
		setTimeout(function() { reject(Error('Timeout')); }, 5000);
	});
}
